// src/components/NavigationSteps.jsx
import React from "react";
import { Link } from "react-router-dom";
import {
  CarOutlined,
  CheckCircleOutlined,
  DeploymentUnitOutlined,
  DesktopOutlined,
  EnvironmentOutlined,
  CompassOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { Card, Typography, Button } from "antd";

const { Text } = Typography;

/**
 * @param {string} selectedKey - la clé (ou chemin) de l'étape sélectionnée
 */
export const NavigationStepsAll = ({ selectedKey }) => {
  // Liste ordonnée des étapes
  const steps = [
    {
      key: "tetra_bus",
      title: "Temp 1",
      label: "Validation TETRA BUS",
      path: "/0f2f796d1947/all/tetra_bus",
      icon: <CarOutlined />,
    },
    {
      key: "po_siel",
      title: "Temp 1",
      label: "Validation PO Siel",
      path: "/0f2f796d1947/all/po_siel",
      icon: <CheckCircleOutlined />,
    },
    {
      key: "prise_service",
      title: "Temp 2",
      label: "Validation Prise de service SAE (1/2)",
      path: "/0f2f796d1947/all/prise_service",
      icon: <DeploymentUnitOutlined />,
    },
    {
      key: "prise_service_coquille",
      title: "Temp 2",
      label: "Validation Prise de service SAE (2/2)",
      path: "/0f2f796d1947/all/prise_service_coquille",
      icon: <DeploymentUnitOutlined />,
    },
    {
      key: "po_siel_sesco",
      title: "Temp 2",
      label: "Validation PO SIEL CESCO",
      path: "/0f2f796d1947/all/po_siel_sesco",
      icon: <DesktopOutlined />,
    },
    {
      key: "po_siel_ad",
      title: "Temp 2",
      label: "Validation PO SIEL salle AD",
      path: "/0f2f796d1947/all/po_siel_ad",
      icon: <DesktopOutlined />,
    },
    {
      key: "geolocalisation",
      title: "Temp 3",
      label: "Géolocalisation de l'AD",
      path: "/0f2f796d1947/all/geolocalisation",
      icon: <EnvironmentOutlined />,
    },
    {
      key: "coquille_config_dsp",
      title: "Tests AD",
      label: "Coquille Config Dsp",
      path: "/0f2f796d1947/all/coquille_config_dsp",
      icon: <CompassOutlined />,
    },
  ];



  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginBottom: "20px" }}>
      {/* Bouton Retour en haut à gauche */}
      <div style={{ display: "flex", justifyContent: "flex-start" }}>
        <Link to="/a87f2430f2" style={{ textDecoration: "none" }}>
          <Button type="primary">Accueil</Button>
        </Link>
      </div>

      {/* Liste des cartes centrée */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "12px",
          justifyContent: "center",
          marginTop: "10px",
        }}
      >
        {steps.map((step) => {
          const active = selectedKey === step.key;

          return (
            <Link key={step.key} to={step.path} style={{ textDecoration: "none" }}>
              <Card
                hoverable
                size="small"
                style={{
                  width: 180,
                  height: 90,
                  borderRadius: 10,
                  boxShadow: active ? "0 0 8px rgba(24, 144, 255, 0.6)" : "0 1px 5px rgba(0,0,0,0.1)",
                  borderColor: active ? "#1677ff" : "#f0f0f0",
                  transition: "all 0.2s ease",
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div style={{ fontSize: 22, color: active ? "#1677ff" : "#999" }}>{step.icon}</div>
                <Text strong style={{ fontSize: 13 }}>{step.title}</Text>
                <div style={{ fontSize: 11, color: "#666", marginTop: 2 }}>{step.label}</div>
              </Card>
            </Link>
          );
        })}

      </div>
    </div>
  );
};
